import React, { useEffect, useRef } from "react";
import { displayFraction, type Fraction } from "../shared/progress.ts";
import "../docs/design/NUMBER_MOTION.js";
/** Animation is presentation only. The final text is formatted from the exact server fraction. */
export function ExactCount({
  value,
  digits = 2,
  scope,
  label,
}: {
  value: Fraction;
  digits?: number;
  scope: string;
  label: string;
}) {
  const ref = useRef<HTMLSpanElement>(null),
    finalText = displayFraction(value, digits);
  const approximate = Number(value.n) / Number(value.d);
  useEffect(() => {
    if (ref.current && Number.isFinite(approximate))
      (window as any).GabineteNumbers?.bind(ref.current, scope);
  }, [value.n, value.d, digits, scope]);
  return (
    <span ref={ref} role="img" aria-label={`${finalText} ${label}`}>
      <span
        aria-hidden="true"
        data-count-key={label}
        data-count-value={
          Number.isFinite(approximate) ? approximate : undefined
        }
        data-count-decimals={digits}
        data-count-fractional={digits > 0 ? "true" : "false"}
        data-count-final={finalText}
      >
        {finalText}
      </span>
    </span>
  );
}
